import { yupResolver } from "@hookform/resolvers/yup";
import Input from "../Input";
import { useForm } from "react-hook-form";
import { useHabUnits } from "../../Providers/HabUnit";
import { useProducts } from "../../Providers/Products";
import * as yup from "yup";
import { IHU, IProductHU } from "../../Interfaces";
import Button from "../Button";
import { Container } from "./styles";

interface IProdsProps {
  HU: IHU;
  prodsState?: IProductHU[];
  updateProdsState: (prods: IProductHU[]) => void;
  closeModal: () => void;
}

interface IFormData {
  id: number;
  quantity: number;
}

const AddProds = ({
  HU,
  updateProdsState,
  prodsState,
  closeModal,
}: IProdsProps) => {
  const { products } = useProducts();
  const { addProduct } = useHabUnits();

  const schema = yup.object().shape({
    id: yup
      .string()
      .required("Campo obrigatório")
      .matches(/^\d+$/, "Apenas números"),
    quantity: yup
      .string()
      .required("Campo obrigatório")
      .matches(/^\d+$/, "Apenas números"),
  });

  const onSubmit = (data: IFormData) => {
    const selectedProduct = products.find((el) => el.id === Number(data.id));

    if (selectedProduct !== undefined && selectedProduct.id !== undefined) {
      const { id, title, price } = selectedProduct;
      const newProduct: IProductHU = {
        id: id,
        title: title,
        price: price,
        quantity: data.quantity,
      };
      addProduct(newProduct, HU);
      if (prodsState !== undefined) {
        updateProdsState([...prodsState, newProduct]);
        closeModal();
      }
    }
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<IFormData>({ resolver: yupResolver(schema) });

  return (
    <Container onSubmit={handleSubmit(onSubmit)}>
      <select {...register("id")}>
        {products?.map((el) => (
          <option key={el.id} value={el.id}>
            {el.title}
          </option>
        ))}
      </select>
      <p className="error">{errors.id && errors.id?.message}</p>
      <Input
        register={register}
        type="number"
        name="quantity"
        className="default"
        label="Quantidade"
      />
      <p className="error">{errors.quantity && errors.quantity?.message}</p>
      <Button type="submit" className="submit">
        Adicionar
      </Button>
    </Container>
  );
};

export default AddProds;
